import { PALETTE } from '../../constants/palette';
import { BaseControlColor } from '../../types';
import { hexToRgba } from '../../utils/hex-to-rgba';

import { baseControlStyles } from './base-control-styles';

export const button = {
  [BaseControlColor.Primary]: {
    normal: {
      ...baseControlStyles.primary.normal,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    hover: {
      ...baseControlStyles.primary.hover,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    active: {
      ...baseControlStyles.primary.active,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    disabled: {
      ...baseControlStyles.primary.disabled,
      text: hexToRgba(PALETTE.white, 0.5),
      icon: hexToRgba(PALETTE.white, 0.5),
    },
  },
  [BaseControlColor.Secondary]: {
    normal: {
      ...baseControlStyles.secondary.normal,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    hover: {
      ...baseControlStyles.secondary.hover,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    active: {
      ...baseControlStyles.secondary.active,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    disabled: {
      ...baseControlStyles.secondary.disabled,
      text: hexToRgba(PALETTE.white, 0.5),
      icon: hexToRgba(PALETTE.white, 0.5),
    },
  },
  [BaseControlColor.SystemRegular]: {
    normal: {
      ...baseControlStyles.systemRegular.normal,
      text: hexToRgba(PALETTE.white, 0.7),
      icon: PALETTE.neutrals.dark.grey700,
    },
    hover: {
      ...baseControlStyles.systemRegular.hover,
      text: hexToRgba(PALETTE.white, 0.7),
      icon: PALETTE.neutrals.dark.grey700,
    },
    active: {
      ...baseControlStyles.systemRegular.active,
      text: hexToRgba(PALETTE.white, 0.7),
      icon: PALETTE.neutrals.dark.grey700,
    },
    disabled: {
      ...baseControlStyles.systemRegular.disabled,
      text: hexToRgba(PALETTE.white, 0.5),
      icon: PALETTE.neutrals.dark.grey300,
    },
  },
  [BaseControlColor.SystemLight]: {
    normal: {
      ...baseControlStyles.systemLight.normal,
      text: hexToRgba(PALETTE.white, 0.7),
      icon: PALETTE.neutrals.dark.grey700,
    },
    hover: {
      ...baseControlStyles.systemLight.hover,
      text: hexToRgba(PALETTE.white, 0.7),
      icon: PALETTE.neutrals.dark.grey700,
    },
    active: {
      ...baseControlStyles.systemLight.active,
      text: hexToRgba(PALETTE.white, 0.7),
      icon: PALETTE.neutrals.dark.grey700,
    },
    disabled: {
      ...baseControlStyles.systemLight.disabled,
      text: hexToRgba(PALETTE.white, 0.5),
      icon: PALETTE.neutrals.dark.grey300,
    },
  },
  [BaseControlColor.Custom100]: {
    normal: {
      ...baseControlStyles.custom100.normal,
      text: PALETTE.accent.brandies,
      icon: PALETTE.accent.brandies,
    },
    hover: {
      ...baseControlStyles.custom100.hover,
      text: PALETTE.accent.brandies,
      icon: PALETTE.accent.brandies,
    },
    active: {
      ...baseControlStyles.custom100.active,
      text: PALETTE.accent.brandies,
      icon: PALETTE.accent.brandies,
    },
    disabled: {
      ...baseControlStyles.custom100.disabled,
      text: PALETTE.accent.brandies,
      icon: PALETTE.accent.brandies,
    },
  },
  [BaseControlColor.CustomDark]: {
    normal: {
      ...baseControlStyles.customDark.normal,
      text: hexToRgba(PALETTE.white, 0.9),
      icon: hexToRgba(PALETTE.white, 0.9),
    },
    hover: {
      ...baseControlStyles.customDark.hover,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    active: {
      ...baseControlStyles.customDark.active,
      text: hexToRgba(PALETTE.white, 0.9),
      icon: hexToRgba(PALETTE.white, 0.9),
    },
    disabled: {
      ...baseControlStyles.customDark.disabled,
      text: hexToRgba(PALETTE.white, 0.4),
      icon: hexToRgba(PALETTE.white, 0.4),
    },
  },
  [BaseControlColor.Custom300]: {
    normal: {
      ...baseControlStyles.custom300.normal,
      text: PALETTE.neutrals.dark.grey600,
      icon: PALETTE.neutrals.dark.grey600,
    },
    hover: {
      ...baseControlStyles.custom300.hover,
      text: PALETTE.neutrals.dark.grey900,
      icon: PALETTE.neutrals.dark.grey900,
    },
    active: {
      ...baseControlStyles.custom300.active,
      text: PALETTE.neutrals.dark.grey600,
      icon: PALETTE.neutrals.dark.grey600,
    },
    disabled: {
      ...baseControlStyles.custom300.disabled,
      text: PALETTE.neutrals.dark.grey180,
      icon: PALETTE.neutrals.dark.grey180,
    },
  },
  [BaseControlColor.Custom400]: {
    normal: {
      ...baseControlStyles.custom400.normal,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    hover: {
      ...baseControlStyles.custom400.hover,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    active: {
      ...baseControlStyles.custom400.active,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    disabled: {
      ...baseControlStyles.custom400.disabled,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
  },
  [BaseControlColor.Custom500]: {
    normal: {
      ...baseControlStyles.custom500.normal,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    hover: {
      ...baseControlStyles.custom500.hover,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    active: {
      ...baseControlStyles.custom500.active,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
    disabled: {
      ...baseControlStyles.custom500.disabled,
      text: PALETTE.white,
      icon: PALETTE.white,
    },
  },
  [BaseControlColor.Transparent]: {
    normal: {
      backgroundImage: 'none',
      backgroundColor: 'transparent',
      text: '#555557',
      icon: '#555557',
    },
    hover: {
      backgroundImage: 'none',
      backgroundColor: 'transparent',
      text: '#555557',
      icon: '#555557',
    },
    active: {
      backgroundImage: 'none',
      backgroundColor: 'transparent',
      text: '#555557',
      icon: '#555557',
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: 'transparent',
      text: '#555557',
      icon: '#555557',
    },
  },
};
